<template>
  <section v-if="Object.keys(process).length" id="printable">
    <div
      class="
        header-label
        is-flex
        is-justify-content-space-between
        is-align-items-center
        has-text-weight-bold
      "
    >
      <span>{{ General.BASIC_DATA }}</span>
      <span
        class="divider is-vertical has-background-color-7 m-0 is-hidden-tablet"
      />
      <span :class="{ 'spacing-mx-10': !isMobile }">
        {{ `${General.SEARCH_DATE}: `
        }}{{ new Date() | dateFormat(isMobile ? "DD/MM/YY" : "DD/MM/YYYY") }}
      </span>
    </div>
    <section v-if="process" class="card-detail">
      <div class="content-left" :class="{ 'spacing-pr-20': !isMobile }">
        <div class="has-text-weight-bold">
          {{ Home.SearchViproc.PROTOCOL.toUpperCase() }} {{ process.protocol }}
        </div>
        <div class="is-size-6 mt-10">
          <span class="has-text-weight-semibold">{{ General.SUBJECT }}: </span>
          <span>{{ process.subject }}</span>
        </div>
        <div class="is-size-6 has-text-weight-normal">
          <div>
            <span class="has-text-weight-semibold">
              {{ General.REGISTRATION_ORGAN }}:
            </span>
            <span> {{ process.origin }}</span>
          </div>
        </div>
        <div
          v-if="process.author_cc && process.author_cc.length"
          class="is-size-6 has-text-weight-normal"
        >
          <span class="has-text-weight-semibold">
            {{ Home.SearchViproc.AUTHOR_FAVORED }}:</span
          >
          <span v-for="(cc, index) in process.author_cc" :key="index">
            {{ cc }}{{ process.author_cc.length - 1 > index ? ", " : "." }}
          </span>
        </div>
      </div>
      <div class="content-right">
        <div class="is-size-6 has-text-weight-normal spacing-mt-10">
          <span class="has-text-weight-semibold">
            {{ General.OPENING_DATE }}:
          </span>
          {{ new Date(process.created_at) | dateFormat("DD/MM/YYYY") }} às
          {{ new Date(process.created_at) | dateFormat("HH:mm") }}
        </div>
      </div>
    </section>

    <template>
      <div class="has-text-weight-semibold header-label spacing-mb-20">
        <span>{{ `${General.PROCEDURES}: ` }}</span>
        <span class="is-size-5">{{ `${timeLine.length} ` }} </span>
      </div>
      <section v-if="timeLine.length" class="timeline-container">
        <TimelineItem
          v-for="(item, index) in timeLine"
          :key="index"
          class="spacing-ml-10"
          statusColor="green-light"
          :dateTitle="new Date(item.date)"
          :hideProgressLine="index === timeLine.length - 1"
        >
          <div class="is-size-6 has-text-weight-normal">
            <p>
              <span class="has-text-weight-semibold"
                >{{ Home.SearchViproc.PART_CAPACITY_FROM }}:
              </span>
              <span>{{ item.origin }}</span>
            </p>
          </div>
          <div class="is-size-6 has-text-weight-normal">
            <p>
              <span class="has-text-weight-semibold"
                >{{ Home.SearchViproc.PART_CAPACITY_TO }}:
              </span>
              <span>{{ item.destination }}</span>
            </p>
          </div>
          <div class="is-size-6 has-text-weight-normal">
            <p>
              <span class="has-text-weight-semibold"
                >{{ General.REASON }}:
              </span>
              <span>{{ item.reason }}</span>
            </p>
          </div>
        </TimelineItem>
      </section>
    </template>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import TimelineItem from "@/components/TimelineItem";

import { App, General, Home } from "@/utils/constants";

import printIcon from "@/assets/svg/print-solid.svg";

export default {
  name: "SearchViewViprocDetail",
  components: {
    TimelineItem
  },

  props: {
    process: {
      type: Object,
      required: true
    },
    timeLine: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      App,
      General,
      Home,
      printIcon
    };
  },

  computed: {
    ...mapGetters({ isMobile: "isMobile" })
  },

  methods: {
    ...mapActions({ getCompletePublicFile: "getCompletePublicFile" }),

    async getPublicFile() {
      const results = await this.getCompletePublicFile(this.process.id);
      results && window.open(results.urlFile, "_blank");
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/variables";

.list-container {
  display: flex;
  flex-direction: column;
  max-height: 700px;
  overflow: auto;
}
.header-label {
  background-color: $color-2;
  print-color-adjust: exact;
  -webkit-print-color-adjust: exact;
  padding: 10px;
  margin: 0 10px;
  border-radius: 5px;

  @media screen and (max-width: $tablet) {
    margin: 0;
  }
}
.card-detail {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 10px 20px;

  @media screen and (max-width: $tablet) {
    display: block;
    padding: 10px 0;
  }
  .content-left {
    display: flex;
    flex-direction: column;
  }
  .view-process {
    color: $blue-oil;
    display: flex;
    align-items: center;
    &:hover {
      color: $highligh-color;
    }
  }
}

.content-right {
  display: flex;
  min-width: 25%;
  flex-direction: column;
}

.due-date-label {
  font-size: 12px;
  color: $orange;
}

.pagination {
  min-width: 30%;
  margin: 0 auto;
}
.button {
  color: #00886c;
  background-color: transparent;
  border: 0px solid #00886c;
  &:hover {
    color: #399999;
    border: 1px solid #00886c;
    background-color: transparent;
  }
}

.timeline-container {
  height: 300px;
  overflow: auto;
  print-color-adjust: exact;
  -webkit-print-color-adjust: exact;

  @media print {
    overflow: visible;
    height: auto;
  }
}

.process-reference:hover {
  color: $color-12;
  text-decoration: underline;
}
</style>
